<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-9 d-print-none d-grid flex-column align-items-start blue"
          [ngClass]="{ gray: !scheduleType?.isActive }"
        >
          <h1>{{ scheduleType?.name }}</h1>
          <span> {{ scheduleSubtype?.name }}</span>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <schedule-types-list
              #list
              [filter]="filter"
              (loading)="setLoading($event, loadingOrigin.Side)"
              (selectedScheduleType)="selectedScheduleType($event)"
              (selectedScheduleSubtype)="selectedScheduleSubtype($event)"
            ></schedule-types-list>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item (click)="list.create()" class="parent" *ngIf="isSA()">
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="details?.createSubtype()"
          class="parent"
          *ngIf="isSA() && scheduleType?.id && !scheduleSubtype"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Subtype</span
          >
          <mat-icon matListItemIcon class="blue">library_add</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <schedule-types-details
            #details
            [scheduleType]="scheduleType"
            *ngIf="!scheduleSubtype"
            (selectedScheduleSubtype)="selectedScheduleSubtype($event)"
          ></schedule-types-details>
          <schedule-subtypes-details
            [scheduleSubtype]="scheduleSubtype"
            *ngIf="scheduleSubtype"
          ></schedule-subtypes-details>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
